import React from "react"

const Blank = ({ color = "#204386" }) => {
  return (
    <svg viewBox="0 0 65 65">
      <path
        fill={color}
        d="M47.9,26.1c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v23.5H13.6V18.9h23.5c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8
	H11.8c-1,0-1.8,0.8-1.8,1.8v36.1c0,1,0.8,1.8,1.8,1.8h36.1c1,0,1.8-0.8,1.8-1.8l0,0V27.9C49.7,26.9,48.9,26.1,47.9,26.1L47.9,26.1
	 M53.3,10H43.1c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7h6.1L31.7,30.9c-0.7,0.7-0.7,1.7,0,2.4s1.7,0.7,2.4,0l17.5-17.5v6.1
	c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7V11.7C55,10.8,54.2,10,53.3,10"
      />
    </svg>
  )
}

export default Blank
